// extracted by mini-css-extract-plugin
export default {"reviewCard":"ReviewCard_reviewCard__up9-r","reviewerInfo":"ReviewCard_reviewerInfo__-DlKc","imgDiv":"ReviewCard_imgDiv__3bEiN"};